// src/subscriptionApi.js
// ── Subscription fetch helper — JobFlow NOW ───────────────────────────────
// Single fetch point for subscription data.
// No global state. No localStorage subscription status.

import { getApiBase } from './apiBase';
import { getTenantHeaders } from './api';

const API_BASE = getApiBase();

/**
 * Fetches the subscription record for the current tenant.
 * Returns the subscription object or null on failure.
 */
export const fetchSubscription = async () => {
  try {
    const res = await fetch(`${API_BASE}/api/settings/subscription`, {
      headers: { ...getTenantHeaders() }
    });

    if (!res.ok) {
      console.error('fetchSubscription failed:', res.status);
      return null;
    }

    return await res.json();
  } catch (err) {
    console.error('fetchSubscription error:', err);
    return null;
  }
};